<ndt-add-extension-group-view
   [callState]="callState | async"
   [extensionGroupPrivileges]="extensionGroupPrivileges$ | async"
   [form]="form"
   [extensionGroup]="extensionGroup"
   [accountId]="accountId | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-extension-group-view>
